<template>
    <div>
        <v-text-field
            v-for="item in items" :key="item.id"
            type="text"
            color="primary"
            outlined
            disabled
            :value="item.full_address"
        />
    </div>
</template>

<script>
export default {
    data() {
        return {
            items: [],
        };
    },
    mounted() {
      this.loadItems();
    },
    methods: {
      loadItems() {
        this.$emit('loading');
        Vue.backendApi().user(this.$store.state.user.id)
            .getAddresses()
            .then((response) => {
                this.$emit('loaded');
                this.items = response.data;
            })
            .catch((err) => {
                this.$emit('loaded');
                this.$swal({
                    type: 'error',
                    title: 'Error loading user addresses',
                    text: err
                });
            });
      },
    },
};
</script>
